import React from "react";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { NetDimensions } from "MODULES/parts/components/shared/Dimensions";
import CentimeterDimensions from "MODULES/parts/components/shared/CentimeterDimensions";
import { NET_HEIGHT, NET_LENGTH, NET_WIDTH } from "MODULES/parts/constants";
import NetWeight from "MODULES/parts/components/shared/NetWeight";

export default ({ getField }) => [
  <h4>Net (Part) Weight & Dims</h4>,
  <FormRow>
    <Col md={4}>
      <NetWeight />
    </Col>
    <Col md={3}>
      <NetDimensions />
    </Col>
    <Col md={3}>
      <CentimeterDimensions
        length={getField(NET_LENGTH)}
        height={getField(NET_HEIGHT)}
        width={getField(NET_WIDTH)}
      />
    </Col>
  </FormRow>
];



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/NetWeightAndDimsFormRow/NetWeightAndDimsFormRow.jsx